import React, { Component } from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import { AppSettings } from "../../constants";
import PhoneNumberInput from "components/PhoneNumberInput";
import InputEditAble from "components/inputEditAble";
import { PlacesWithStandaloneSearchBox } from "components/geo-complete/CustomMap";
import { SwitchButton } from "components/switch-button";

class BuilderInformationModal extends Component {
  static propTypes = {
    onSave: PropTypes.func,
    modalName: PropTypes.string,
    onUpdateBuilderInformation: PropTypes.func,
    onUpdateLotsAction: PropTypes.func,
    onUpdateHORFSAction: PropTypes.func,
    item: PropTypes.object,
    show: PropTypes.bool,
    closeModal: PropTypes.func,
    initialLotsEnabled: PropTypes.bool,
    initialHORFSEnabled: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      location: {},
      isEditBuilderInformation: {},
      itemData: props.item || {},
      lotsEnabled: props.initialLotsEnabled || false,
      hoRFSEnabled: props.initialHORFSEnabled || false,
    };
    this.handleSwitchChange = this.handleSwitchChange.bind(this);
    this.handleHORFSSwitchChange = this.handleHORFSSwitchChange.bind(this);
  }

  onChangeMap = (mapState) => {
    const location = { ...this.state.location };
    location.fullLocation = mapState.fullLocation;
    location.city = mapState.city;
    location.state = mapState.state;
    location.postalCode = mapState.postalCode;
    this.setState({ location });
  };

  onToggleEditBuilderInformation = (field) => () => {
    this.setState({
      errorMessage: null,
      isEditBuilderInformation: {
        [field]: !this.state.isEditBuilderInformation[field],
      },
    });
  };

  componentWillReceiveProps(nextProps) {
    const newState = {};

    // Update itemData if a new item is passed
    if (nextProps.item && nextProps.item !== this.props.item) {
      newState.itemData = nextProps.item;
    }

    // 3. Update the lotsEnabled state if the prop changes.
    // This ensures the switch is correct if the modal is re-used for different items.
    if (nextProps.initialLotsEnabled !== this.props.initialLotsEnabled) {
      newState.lotsEnabled = nextProps.initialLotsEnabled;
    }

    if (nextProps.initialHORFSEnabled !== this.props.initialHORFSEnabled) {
      newState.hoRFSEnabled = nextProps.initialHORFSEnabled;
    }

    if (Object.keys(newState).length > 0) {
      this.setState(newState);
    }
  }

  updateBuilderInformation = (value) => {
    let data = value;

    const { location, itemData } = this.state;

    if (location.fullLocation && !location.state) {
      this.setState({
        errorMessage: "Invalid location. Please pick a location from the list.",
      });
    } else {
      if (Object.keys(value)[0] === "streetAddress") {
        data["location"] = location;
      }

      this.props.onUpdateBuilderInformation(
        {
          id: itemData.id,
          data,
        },
        () => {
          this.setState({
            errorMessage: null,
            isEditBuilderInformation: {},
          });
        },
      );
    }
  };

  renderClientStatus() {
    const { itemData } = this.state;
    if (itemData.clientStatus === AppSettings.CLIENT_STATUS.ACTIVE) {
      return (
        <label className="label label-success builder-info-modal__tag">
          {itemData.clientStatusValue}
        </label>
      );
    }

    return (
      <label className="label label-danger builder-info-modal__tag">
        {itemData.clientStatusValue}
      </label>
    );
  }

  renderLogo() {
    const { itemData } = this.state;
    let src = "";
    if (!itemData.logoUrl || itemData.logoUrl.split("\\")[0] === "images") {
      src = "images/no-picture.png";
    } else {
      src = itemData.logoUrl;
    }
    return (
      <div className="row">
        <div className="col-md-9" style={{ marginBottom: 15 }}>
          <div
            className="logo-thumbnail"
            style={{ height: 64, position: "relative", overflow: "hidden" }}
          >
            <img className="cls-logo" src={src} />
          </div>
        </div>
      </div>
    );
  }

  renderValue = (value) => {
    if (value) {
      return <span className="builder-info-modal__value">{value}</span>;
    }
    return (
      <span className="builder-info-modal__value--null">(Not specified)</span>
    );
  };

  handleSwitchChange(checked) {
    const { itemData } = this.state; // Use state instead of props
    if (!itemData || !itemData.id) {
      console.error("Item data is not available");
      return;
    }

    this.setState({ lotsEnabled: checked });

    this.props.onUpdateLotsAction(itemData, checked, () => {
      if (this._isMounted) {
        this.setState({
          errorMessage: null,
          isEditBuilderInformation: {},
        });
      }
    });
  }

  handleHORFSSwitchChange(checked) {
    const { itemData, lotsEnabled } = this.state;
    if (!itemData || !itemData.id) {
      console.error("Item data is not available");
      return;
    }

    const previousChecked = this.state.hoRFSEnabled;
    this.setState({ hoRFSEnabled: checked });

    this.props.onUpdateHORFSAction(
      itemData,
      checked,
      lotsEnabled,
      (result, hasError) => {
        if (!this._isMounted) {
          return;
        }

        // Roll the switch back if the request did not go through
        if (hasError) {
          this.setState({ hoRFSEnabled: previousChecked });
          return;
        }

        this.setState({
          errorMessage: null,
          isEditBuilderInformation: {},
        });
      },
    );
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const { itemData: item } = this.state; // Use state as the source of truth
    const { isEditBuilderInformation } = this.state;

    if (!item || !item.id) {
      return null; // Don't render if there is no item data
    }

    return (
      <div className="">
        <Modal
          show={this.props.show}
          onHide={this.props.closeModal}
          dialogClassName="custom-modal"
          backdrop="static"
          keyboard={false}
          container={this}
          id="rename-modal"
          className="builder-info-modal"
        >
          <Modal.Body>
            <div className="row">
              <div className="col-md-12">
                {isEditBuilderInformation.clientName ? (
                  <div style={{ marginBottom: 10 }}>
                    <InputEditAble
                      defaultValue={item.clientName}
                      inputName="clientName"
                      autoFocus
                      onSubmit={this.updateBuilderInformation}
                      onCancel={this.onToggleEditBuilderInformation(
                        "clientName",
                      )}
                      actionButtonPosition={"bottom"}
                      ignoreOnBlur={true}
                    />
                  </div>
                ) : (
                  <div>
                    <span className="builder-info-modal__title ellipsis">
                      {item.clientName}
                    </span>
                    <i
                      className="fa fa-pencil subcontractor-edit-trade-btn"
                      onClick={this.onToggleEditBuilderInformation(
                        "clientName",
                      )}
                      style={{ transform: "translateY(-4px)" }}
                    />
                  </div>
                )}
              </div>
            </div>

            {this.renderLogo()}

            <div className="row">
              <div className="col-md-12">
                {isEditBuilderInformation.clientPhone ? (
                  <div>
                    <div style={{ marginBottom: 5 }}>
                      Company phone <span className="text-danger"> *</span>
                    </div>
                    <PhoneNumberInput
                      ref={(ref) => {
                        this.clientPhone = ref;
                      }}
                      name="clientPhone"
                      defaultValue={item.clientPhone}
                      editAble
                      isRequired
                      autoFocus
                      ignoreOnBlur
                      actionButtonPosition="top"
                      onSubmit={this.updateBuilderInformation}
                      onCancel={this.onToggleEditBuilderInformation(
                        "clientPhone",
                      )}
                    />
                  </div>
                ) : (
                  <div>
                    <span className="builder-info-modal__label">
                      Company phone
                    </span>
                    <div className="value-block">
                      {this.renderValue(item.clientPhone)}
                      <i
                        className="fa fa-pencil subcontractor-edit-trade-btn"
                        onClick={this.onToggleEditBuilderInformation(
                          "clientPhone",
                        )}
                      />
                    </div>
                  </div>
                )}
              </div>
              <div className="col-md-12">
                {isEditBuilderInformation.clientEmail ? (
                  <div>
                    <div style={{ marginBottom: 5 }}>
                      Email address <span className="text-danger"> *</span>
                    </div>
                    <InputEditAble
                      defaultValue={item.clientEmail}
                      inputName="clientEmail"
                      autoFocus
                      onSubmit={this.updateBuilderInformation}
                      onCancel={this.onToggleEditBuilderInformation(
                        "clientEmail",
                      )}
                      actionButtonPosition={"top"}
                      ignoreOnBlur={true}
                      maxLength={256}
                      validEmail={true}
                    />
                  </div>
                ) : (
                  <div>
                    <span className="builder-info-modal__label">
                      Email address
                    </span>
                    <div className="value-block">
                      {this.renderValue(item.clientEmail)}
                      <i
                        className="fa fa-pencil subcontractor-edit-trade-btn"
                        onClick={this.onToggleEditBuilderInformation(
                          "clientEmail",
                        )}
                      />
                    </div>
                  </div>
                )}
              </div>
              <div className="col-md-12">
                <span className="builder-info-modal__label">
                  Company domain
                </span>
                <div className="value-block">
                  {this.renderValue(item.domain)}
                </div>
              </div>
              <div className="col-md-12">
                {isEditBuilderInformation.streetAddress ? (
                  <div>
                    <div style={{ marginBottom: 5 }}>
                      Location
                      <i
                        className="fa fa-check subcontractor-edit-trade-btn pull-right"
                        onClick={() =>
                          this.updateBuilderInformation({
                            streetAddress: this.state.location.fullLocation,
                          })
                        }
                      />
                      <i
                        className="fa fa-close subcontractor-edit-trade-btn pull-right"
                        onClick={this.onToggleEditBuilderInformation(
                          "streetAddress",
                        )}
                      />
                    </div>
                    <PlacesWithStandaloneSearchBox
                      className="search-box"
                      defaultValue={item.streetAddress}
                      ref={(c) => {
                        this.location = c;
                      }}
                      onChange={this.onChangeMap}
                    />
                    {this.state.errorMessage && (
                      <span className="cls-danger help-block">
                        {this.state.errorMessage}
                      </span>
                    )}
                  </div>
                ) : (
                  <div>
                    <span className="builder-info-modal__label">Location</span>
                    <div className="value-block">
                      {this.renderValue(item.streetAddress)}
                      <i
                        className="fa fa-pencil subcontractor-edit-trade-btn"
                        onClick={this.onToggleEditBuilderInformation(
                          "streetAddress",
                        )}
                      />
                    </div>
                  </div>
                )}
              </div>
              <div className="col-md-12">
                <span className="builder-info-modal__label">Status</span>
                <div className="value-block">
                  {this.renderValue(item.clientStatusValue)}
                </div>
              </div>
              <div className="col-md-12">
                <div className="builder-info-modal__label">Lots</div>
                <div className="value-block">
                  <SwitchButton
                    name="lotsSwitch"
                    checked={this.state.lotsEnabled}
                    style={{
                      display: "inline-block",
                      verticalAlign: "middle",
                    }}
                    onCheck={(checked) => this.handleSwitchChange(checked)}
                  />
                </div>
              </div>
              <div className="col-md-12">
                <div className="builder-info-modal__label">
                  HO Request For Service
                </div>
                <div className="value-block">
                  <SwitchButton
                    name="requestForServiceSwitch"
                    checked={this.state.hoRFSEnabled}
                    style={{
                      display: "inline-block",
                      verticalAlign: "middle",
                    }}
                    onCheck={(checked) => this.handleHORFSSwitchChange(checked)}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <p className="builder-info-modal__sub-title">
                  Site's super admin
                </p>
              </div>
              <div className="col-md-12">
                <span className="builder-info-modal__label">Full name</span>
                <div className="value-block">
                  {this.renderValue(item.ownerFirstName + item.ownerLastName)}
                </div>
              </div>
              <div className="col-md-12">
                <span className="builder-info-modal__label">Email address</span>
                <div className="value-block">
                  {this.renderValue(item.ownerEmail)}
                </div>
              </div>
              <div className="col-md-12">
                <span className="builder-info-modal__label">Status</span>
                <div className="value-block">{this.renderClientStatus()}</div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12" style={{ marginTop: 15 }}>
                <button
                  className="btn btn-primary btn-siteone-default"
                  onClick={this.props.closeModal}
                >
                  Close
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

BuilderInformationModal.propTypes = {
  closeModal: PropTypes.func,
  toggleModal: PropTypes.func,
  modalName: PropTypes.string,
  logoUrl: PropTypes.string,
  item: PropTypes.object,
  show: PropTypes.bool,
  title: PropTypes.string,
  initialLotsEnabled: PropTypes.bool,
  initialHORFSEnabled: PropTypes.bool,
};

export default BuilderInformationModal;



// WEBPACK FOOTER //
// ./src/Builders/Components/BuilderInformationModal.js